export default "__VITE_ASSET__3Gr$sKhP__"